import type { PerUnitProduct, TiersProduct } from '@weft/services';
import { isTieredSubscriptionUsageProductOnly } from '@weft/services';
import { isPerUnitUsageProductOnly, isTiersUsageProductOnly } from '@weft/services';
import type { BillingInterval, UsageProduct, UsageProductInput } from '@weft/types';
import { raise } from '@weft/utils';
import React from 'react';
import { PerUnitUsageCharge } from './PerUnitUsageCharge/PerUnitUsageCharge';
import { PerUnitUsageChargeEdit } from './PerUnitUsageChargeEdit/PerUnitUsageChargeEdit';
import { TieredSubscriptionUsageCharge } from './TieredSubscriptionUsageCharge/TieredSubscriptionUsageCharge';
import { TieredSubscriptionUsageChargeEdit } from './TieredSubscriptionUsageChargeEdit/TieredSubscriptionUsageChargeEdit';
import { TiersUsageCharge } from './TiersUsageCharge';
import { TiersUsageChargeEdit } from './TiersUsageChargeEdit';

type UsageChargeProps = {
  product: UsageProduct | UsageProductInput;
  billingInterval: BillingInterval;
  editable: boolean;
};

export const UsageCharge: React.FC<UsageChargeProps> = ({ product, billingInterval, editable }) => {
  const createUsageCharge = useUsageChargeFactory();
  
  return createUsageCharge(product, billingInterval, editable);
};

function useUsageChargeFactory() {
  return (product: UsageProduct | UsageProductInput, billingInterval: BillingInterval, editable: boolean) => {
    if (isTiersUsageProductOnly<TiersProduct>(product)) {
      return editable
        ? <TiersUsageChargeEdit billingInterval={billingInterval} />
        : <TiersUsageCharge />;
    }

    if (isPerUnitUsageProductOnly<PerUnitProduct>(product)) {
      return editable
        ? <PerUnitUsageChargeEdit />
        : <PerUnitUsageCharge />;
    }

    if (isTieredSubscriptionUsageProductOnly(product)) {
      return editable
        ? <TieredSubscriptionUsageChargeEdit billingInterval={billingInterval}/>
        : <TieredSubscriptionUsageCharge />;
    }

    return raise(`Unknown usage product type: ${JSON.stringify(product, null, 2)}`);
  };
}